import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@unite-us/ui';
import { theme } from '../../../tailwind.config';
var RemoveFieldRowButton = function RemoveFieldRowButton(_ref) {
  var onClick = _ref.onClick,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement("div", {
    className: "w-1/12 self-end pb-10 pl-3"
  }, /*#__PURE__*/React.createElement("button", {
    className: "transform translate-y-1",
    "data-test-element": testId,
    "data-testid": testId,
    onClick: onClick,
    type: "button",
    "aria-label": "remove row"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "V2Delete",
    color: theme.extend.colors['current-blue']
  })));
};
RemoveFieldRowButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  testId: PropTypes.string.isRequired
};
export default RemoveFieldRowButton;
//# sourceMappingURL=ButtonRemoveField.js.map